import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { API } from '../lib/api';

const ContentContext = createContext({ content: {}, loading: true, refresh: () => {} });

export function ContentProvider({ children }) {
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/content`);
      setContent(data || {});
    } catch (e) {
      console.error('Failed to load site content', e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <ContentContext.Provider value={{ content, loading, refresh }}>
      {children}
    </ContentContext.Provider>
  );
}

export function useContent() {
  return useContext(ContentContext);
}

// Convenient hook: returns content for a single section
export function useSection(section) {
  const { content } = useContext(ContentContext);
  return content[section] || {};
}

// Resolve image URL - if relative API path, prepend backend URL
export function resolveImage(url) {
  if (!url) return '';
  if (url.startsWith('/api/')) {
    const backend = process.env.REACT_APP_BACKEND_URL || '';
    return `${backend}${url}`;
  }
  return url;
}
